import { unsupported } from '../errors'
import type { AyudaService, Contact, HelpStay } from './types'

/** Contacto de la app actual (Home.tsx: `tel:` con `roomData.supportPhone` y `wa.me/{hotelWhatsApp}`), ya leído con E1. */
export function contactFromStay(stay: HelpStay): Contact {
  return { whatsapp: stay.contact.whatsapp, email: null, phone: stay.contact.supportPhone, emergencyPhone: stay.contact.emergencyPhone, reference: stay.reference }
}


export const ayudaReal: AyudaService = {
  getContact(stay) {
    return Promise.resolve(contactFromStay(stay))
  },
  // Preguntas frecuentes e historial de la conversación: no existen en la API actual (inventario 8.9, D51).
  getFaq: unsupported,
  getConversation: unsupported,
}
